<template>
  <div>
    <div v-if="nbOfErrors > 0">
      <div class="bs3-padding text-center bs3-margin-left-minus15 bs3-margin-right-minus15 bg-danger">
        <span class="label label-danger">{{ nbOfErrors | error(pDictionary) }}</span>
      </div>
    </div>

    <div class="bs3-margin-bottom20">
      <h3>{{ 'dictionary.invoice.cmd.split.consequence.warning.1' | i18nText(pDictionary) }}</h3>

      <p class="lead">{{ 'dictionary.invoice.cmd.split.consequence.warning.2' | i18nText(pDictionary) }}</p>

      <div class="alert alert-info" role="alert">
        <span class="label label-info bs3-margin-right10">{{ 'dictionary.invoice.cmd.split.invoice' | i18nText(pDictionary) }}</span>
        <span>{{ dataForm.srcInvoiceRef.params.periodStartDate }} - {{ dataForm.srcInvoiceRef.params.periodEndDate }}</span>
      </div>

      <h4>{{ 'dictionary.invoice.cmd.split.consequence.warning.3' | i18nText(pDictionary) }}</h4>
      <table class="table">
        <tbody>
        <tr class="table-borderless-top">
          <td :class="['minWidthCell text-nowrap bs3-padding-left-reset', {'has-error bg-danger': hasFieldErrors('bulkCmdDataForm.splitDirectionText')}]">
            <label class="sr-only" for="bulkCmdDataForm_splitDirectionText">
              {{ 'dictionary.invoice.cmd.split.direction' | i18nText(pDictionary) }}
            </label>
            <select ref="splitDirectionSelect" class="form-control selectpicker" id="bulkCmdDataForm_splitDirectionText"
                    name="bulkCmdDataForm.splitDirectionText"
                    v-model="dataForm.splitDirectionText"
                    data-container="#ajaxModuleFormModalDialog">
              <option value="PRECEDING"
                      :data-content="'<i class=\'fa-light fa-arrow-up\'></i> ' + pDictionary['dictionary.invoice.cmd.split.direction.preceding']">
                {{ 'dictionary.invoice.cmd.split.direction.preceding' | i18nText(pDictionary) }}
              </option>
              <option value="FOLLOWING"
                      :data-content="'<i class=\'fa-light fa-arrow-down\'></i> ' + pDictionary['dictionary.invoice.cmd.split.direction.following']">
                {{ 'dictionary.invoice.cmd.split.direction.following' | i18nText(pDictionary) }}
              </option>
            </select>
            <span v-for="(error, errorIndex) in getFieldErrors('bulkCmdDataForm.splitDirectionText')"
                  :key="'errorList_bulkCmdDataForm_splitDirectionText' + errorIndex" class="help-block">{{ error }}</span>
          </td>
          <td v-show="splitDirectionPreceding" class="minWidthCell text-center"><p class="form-control-static">{{'dictionary.general.from' | i18nText(pDictionary)}}</p></td>
          <td v-show="splitDirectionPreceding" class="width150Pixels text-right">
            <div class="input-group width150Pixels">
              <span class="input-group-addon"><i class="fa-light fa-calendar"></i></span>
              <input type="text"
                     :value="dataForm.srcInvoiceRef.params.periodStartDate"
                     class="form-control"
                     size="10" maxlength="10"
                     autocomplete="off" disabled>
            </div>
          </td>
          <td v-show="splitDirectionPreceding" class="minWidthCell text-center"><p class="form-control-static">{{'dictionary.general.to' | i18nText(pDictionary)}}</p></td>
          <td v-show="splitDirectionFollowing" class="minWidthCell text-center"><p class="form-control-static">{{'dictionary.general.from' | i18nText(pDictionary)}}</p></td>
          <td :class="['minWidthCell text-center', {'has-error bg-danger': hasFieldErrors('bulkCmdDataForm.splitDateText')}]">
            <div class="input-group width150Pixels">
              <span class="input-group-addon"><i class="fa-light fa-calendar"></i></span>
              <input type="text" v-model="dataForm.splitDateText"
                     id="bulkCmdDataForm_splitDateText" ref="splitDateText"
                     name="bulkCmdDataForm.splitDateText"
                     :placeholder="pDictionary['dictionary.format.date.hint']"
                     class="form-control datepicker splitDateText"
                     size="10" maxlength="10"
                     autocomplete="off">
            </div>
            <span v-for="(error, errorIndex) in getFieldErrors('bulkCmdDataForm.splitDateText')"
                  :key="'errorList_bulkCmdDataForm_splitDateText' + errorIndex" class="help-block">{{ error }}</span>
          </td>
          <td v-show="splitDirectionFollowing" class="minWidthCell text-center"><p class="form-control-static">{{'dictionary.general.to' | i18nText(pDictionary)}}</p></td>
          <td v-show="splitDirectionFollowing" class="width150Pixels text-left">
            <div class="input-group width150Pixels">
              <span class="input-group-addon"><i class="fa-light fa-calendar"></i></span>
              <input type="text"
                     :value="dataForm.srcInvoiceRef.params.periodEndDate"
                     class="form-control"
                     size="10" maxlength="10"
                     autocomplete="off" disabled>
            </div>
          </td>
          <td></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "InvoiceSplitCmdForm",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pDataForm: Object
  },
  data: function () {
    return {
      dataForm: this.pDataForm
    }
  },
  computed: {
    splitDirectionPreceding: function () {
      return this.dataForm.splitDirectionText === 'PRECEDING';
    },
    splitDirectionFollowing: function () {
      return this.dataForm.splitDirectionText === 'FOLLOWING';
    }
  },
  watch: {
    splitDirectionPreceding: function (newSplitDirectionPreceding) {
      if(newSplitDirectionPreceding)
      {
        let $splitDateText = $(this.$refs.splitDateText);
        $splitDateText.datepicker('option', {minDate: this.dataForm.precedingSplitDateMin, maxDate: this.dataForm.precedingSplitDateMax});
      }
    },
    splitDirectionFollowing: function (newSplitDirectionFollowing) {
      if(newSplitDirectionFollowing)
      {
        let $splitDateText = $(this.$refs.splitDateText);
        $splitDateText.datepicker('option', {minDate: this.dataForm.followingSplitDateMin, maxDate: this.dataForm.followingSplitDateMax});
      }
    }
  },
  mounted: function () {
    let _component = this;

    /* SPLIT DIRECTION */
    let $splitDirectionSelect = $(_component.$refs.splitDirectionSelect);
    $splitDirectionSelect.selectpicker();
    $splitDirectionSelect.on('changed.bs.select', function (e, clickedIndex) {
      let $bsSelect = $(e.target);
      let $clickedOption = $bsSelect.find('option').eq(clickedIndex);
      if($clickedOption.val() <= 0)
      {
        $.each($bsSelect.find(":selected").not($clickedOption), function (index, option) {
          let $option = $(option);
          $option.prop('selected', false);
        });
      }
      else
      {
        $.each($bsSelect.find(":selected").not($clickedOption), function (index, option) {
          let $option = $(option);
          if($option.val() <= 0)
          {
            $option.prop('selected', false);
          }
        });
      }
      $bsSelect.selectpicker('refresh');
    });

    /* SPLIT DATE */
    let $splitDateText = $(this.$refs.splitDateText);
    console.log("$splitDateText", $splitDateText)
    $splitDateText.initFromDatePicker(
        {
          dateElId: $splitDateText.attr('id'),
          linkDateElId: null,
          minDate: _component.dataForm.precedingSplitDateMin,
          maxDate: _component.dataForm.precedingSplitDateMax,
          bs3: true,
          f: function (selectedDate) {
            _component.$data.dataForm.splitDateText = selectedDate;
            _component.$refs.splitDateText.dispatchEvent(new Event('change'));
          }, noWeekends: false
        });
  },
  updated: function () {
    let _component = this;
    let $splitDirectionSelect = $(_component.$refs.splitDirectionSelect);
    $splitDirectionSelect.selectpicker('refresh');
  },
  destroyed: function () {
    let _component = this;
    let $splitDirectionSelect = _component.$refs.splitDirectionSelect;
    $splitDirectionSelect.selectpicker('destroy');
  }
}
</script>

<style scoped>

</style>